export const createSet = (iterable) => new Set(iterable);
export const addToSet = (set, value) => (set.add(value), value);
export const hasInSet = (set, value) => set.has(value);
export const deleteFromSet = (set, value) => set.delete(value);
export const clearSet = (set) => set.clear();
export const entriesFromSet = (set) => set.entries();
export const forEachOfSet = (set, callbackFn, thisArg) => set.forEach(callbackFn, thisArg);
export const keysFromSet = (set) => set.keys();
export const sizeOfSet = (set) => set.size;
